/**
 * iter86.77.17 — "Looks finished — mark it complete" nudge for CUSTOM
 * tournaments (manual scores). API-driven templates auto-close a day
 * after the last game instead (backend auto_complete.py sweep), so
 * this banner intentionally never renders for them.
 */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Flag, X } from "lucide-react";

export function isApiDrivenTemplate(tournament) {
    const tpl = tournament?.template || "";
    return tpl.startsWith("golf_") || tpl === "nfl_season_api" || !!tournament?.api_football_league_id;
}

export default function CompleteNudgeBanner({ leagueId, tournament, champion, matches }) {
    const navigate = useNavigate();
    const dismissKey = `tcr_complete_nudge_dismissed_${tournament?.id}`;
    const [dismissed, setDismissed] = useState(() => {
        try { return localStorage.getItem(dismissKey) === "1"; } catch { return false; }
    });

    if (!tournament || tournament.completion_authorized_by || dismissed) return null;
    if (isApiDrivenTemplate(tournament)) return null;
    const allPlayed = (matches?.length || 0) > 0 && matches.every(m => m.played);
    if (!champion && !allPlayed) return null;

    const dismiss = () => {
        try { localStorage.setItem(dismissKey, "1"); } catch { /* noop */ }
        setDismissed(true);
    };

    return (
        <div className="brutal-card p-4 border-blaze bg-blaze/10 flex items-center gap-3 flex-wrap" data-testid="complete-nudge-banner">
            <Flag className="w-5 h-5 text-blaze shrink-0" />
            <div className="flex-1 min-w-[220px]">
                <p className="font-display font-extrabold uppercase text-sm">
                    {champion ? `${champion.name} took the crown — this one looks finished` : "Every game has been played — this one looks finished"}
                </p>
                <p className="text-xs text-zinc-400 mt-0.5">
                    Mark the tournament complete to lock results and start the wrap-up. You can still do it later from Tournament Admin → Danger Zone.
                </p>
            </div>
            <div className="flex items-center gap-2 shrink-0">
                <button
                    data-testid="complete-nudge-go-btn"
                    onClick={() => navigate(`/league/${leagueId}/admin?scope=tournament&tournament_id=${tournament.id}&tab=danger_zone&action=mark_complete`)}
                    className="brutal-btn text-xs py-2 bg-blaze text-white border-black shadow-brutal"
                >
                    <Flag className="w-3.5 h-3.5" /> Mark complete
                </button>
                <button
                    data-testid="complete-nudge-dismiss-btn"
                    onClick={dismiss}
                    aria-label="Dismiss"
                    className="p-2 border-2 border-[#333] rounded-md text-zinc-500 hover:text-white hover:border-zinc-500 transition-colors"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
}
